import { render, staticRenderFns } from "./MySignaturePad.vue?vue&type=template&id=4368c8c6&scoped=true&"
import script from "./MySignaturePad.vue?vue&type=script&lang=ts&"
export * from "./MySignaturePad.vue?vue&type=script&lang=ts&"
import style0 from "./MySignaturePad.vue?vue&type=style&index=0&id=4368c8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368c8c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VRow})
